"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AIForm = void 0;
var tslib_1 = require("tslib");
var package_json_1 = tslib_1.__importDefault(require("../../package.json"));
var config_1 = require("../config");
var types_1 = require("../types");
var utils_1 = require("../utils");
var TOTAL_RETRIES = 15;
var SESSIONID_KEY = "oniroco_session_id";
var AIForm = (function () {
    function AIForm(_a) {
        var apiKey = _a.apiKey, language = _a.language, customerData = _a.customerData, context = _a.context, colorScheme = _a.colorScheme, text = _a.text, timezone = _a.timezone, theme = _a.theme, useNewDomain = _a.useNewDomain;
        this.isFileUploadAllowed = false;
        this.loaded = false;
        this.initialized = false;
        this.subscriptions = [];
        this.retries = 0;
        this.context = {};
        this.colorScheme = "light";
        if (this.initialized)
            throw new Error("AIForm is already initialized");
        this.apiKey = apiKey;
        this.timezone = timezone;
        this.customerData = customerData;
        this.useNewDomain = useNewDomain;
        this.frameId = Date.now().toString(16);
        this.sessionId = this.initSessionId();
        if (text)
            this.setText(text);
        if (context)
            this.context = context;
        if (theme)
            this.setInitialTheme(theme);
        if (colorScheme)
            this.setColorScheme(colorScheme);
        if (language && language.length >= 2) {
            this.language = language.slice(0, 2);
        }
    }
    AIForm.prototype.embed = function (_a) {
        return tslib_1.__awaiter(this, arguments, void 0, function (_b) {
            var _this = this;
            var selector = _b.selector;
            return tslib_1.__generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        if (!selector)
                            throw new Error("Selector is required");
                        if (!document.querySelector(selector))
                            throw new Error("Selector is not found in your DOM");
                        if (this.loaded)
                            return [2, console.error("Has already been embedded")];
                        this.selector = selector;
                        return [4, this.getConfig()];
                    case 1:
                        _c.sent();
                        if (!this.config)
                            return [2];
                        if (this.config.advanced.isHidden) {
                            console.warn("AI form has been hidden, re-enable it in your dashboard");
                            return [2];
                        }
                        return [4, (0, utils_1.waitUntilDocumentIsReady)()];
                    case 2:
                        _c.sent();
                        this.frame = (0, utils_1.createIframe)(tslib_1.__assign(tslib_1.__assign(tslib_1.__assign({}, config_1.frameConfig.aiForm), (this.useNewDomain === true ? { src: "https://ai-form-client.oniroco.tech" } : {})), { id: this.frameId, selector: selector }));
                        (0, utils_1.setFrameVisibility)({ frame: this.frame, isVisible: false });
                        this.initialized = true;
                        this.addMessageListener();
                        _c.label = 3;
                    case 3:
                        this.retries += 1;
                        (0, utils_1.sendMessageToFrame)({
                            type: "init",
                            frame: this.frame,
                            frameId: this.frameId,
                            payload: {
                                type: "embed",
                                text: this.text,
                                config: this.config,
                                apiKey: this.apiKey,
                                context: this.context,
                                language: this.language,
                                sessionId: this.sessionId,
                                theme: this.getTheme(),
                                size: (0, utils_1.formatWindowSize)(),
                                customerData: this.customerData,
                                colorScheme: this.getColorScheme(),
                            },
                        });
                        return [4, (0, utils_1.wait)(250 * this.retries)];
                    case 4:
                        _c.sent();
                        _c.label = 5;
                    case 5:
                        if (!this.loaded && this.retries < TOTAL_RETRIES) return [3, 3];
                        _c.label = 6;
                    case 6:
                        if (this.retries >= TOTAL_RETRIES) {
                            console.error("ERROR_TIME_OUT Could not embed ai form");
                            return [2];
                        }
                        window.addEventListener("beforeunload", function () {
                            if (!_this.frame)
                                return;
                            _this.unload();
                            (0, utils_1.sendMessageToFrame)({ frameId: _this.frameId, frame: _this.frame, type: "parent.closed" });
                        });
                        window.addEventListener("resize", function () {
                            if (!_this.frame)
                                return;
                            (0, utils_1.sendMessageToFrame)({
                                frame: _this.frame,
                                frameId: _this.frameId,
                                type: "parent.resized",
                                payload: { size: (0, utils_1.formatWindowSize)() },
                            });
                        });
                        return [2];
                }
            });
        });
    };
    AIForm.prototype.getConfig = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var result, jsonResult_1, jsonResult, error_1, err;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 5, , 6]);
                        return [4, fetch("".concat(process.env.API_BASE_URL, "/sdk/v1/ai-form/get-config"), {
                                headers: { "x-api-key": this.apiKey },
                            })];
                    case 1:
                        result = _a.sent();
                        if (!(result.status === 403)) return [3, 3];
                        return [4, result.json()];
                    case 2:
                        jsonResult_1 = _a.sent();
                        throw new Error(jsonResult_1 === null || jsonResult_1 === void 0 ? void 0 : jsonResult_1.message);
                    case 3:
                        if (result.status !== 200)
                            throw new Error("API key is not valid, Could not init AI form");
                        return [4, result.json()];
                    case 4:
                        jsonResult = _a.sent();
                        if (!jsonResult)
                            throw new Error("Could not init AI form");
                        this.setConfigTheme(jsonResult);
                        this.setConfigLanguage(jsonResult);
                        this.config = jsonResult;
                        this.timezone = jsonResult.timezone;
                        this.isFileUploadAllowed = jsonResult.permissions.isUploadEnabled;
                        return [3, 6];
                    case 5:
                        error_1 = _a.sent();
                        err = error_1;
                        this.initialized = false;
                        console.error(err.message);
                        return [2, false];
                    case 6: return [2, true];
                }
            });
        });
    };
    AIForm.prototype.addMessageListener = function () {
        var _this = this;
        window.addEventListener("message", function (event) {
            var _a = event.data, type = _a.type, payload = _a.payload;
            if (!_this.frame || _this.frameId !== event.data.frameId)
                return;
            switch (type) {
                case "initialized":
                    _this.loaded = true;
                    if ((payload === null || payload === void 0 ? void 0 : payload.frameConfig) && _this.frame) {
                        (0, utils_1.resizeFrame)({ frame: _this.frame, config: payload.frameConfig });
                    }
                    (0, utils_1.setFrameVisibility)({ frame: _this.frame, isVisible: true });
                    break;
                case "parent.resize":
                    (0, utils_1.resizeFrame)({ frame: _this.frame, config: payload });
                    break;
                default:
                    break;
            }
            (0, utils_1.executeSubscriptions)({ events: [type], subscriptions: _this.subscriptions, payload: payload });
        });
    };
    AIForm.prototype.isLoaded = function () {
        return this.loaded;
    };
    AIForm.prototype.getVersion = function () {
        return package_json_1.default.version;
    };
    AIForm.prototype.getLanguage = function () {
        return this.language;
    };
    AIForm.prototype.setLanguage = function (language) {
        var _a, _b;
        if ((language === null || language === void 0 ? void 0 : language.length) !== 2) {
            console.error("Language is invalid. Must be ISO 639-1");
            return;
        }
        if (this.config && !((_b = (_a = this.config) === null || _a === void 0 ? void 0 : _a.languages) === null || _b === void 0 ? void 0 : _b.includes(language))) {
            console.error("Language is not supported in your project.");
            return;
        }
        this.language = language;
        if (this.frame)
            (0, utils_1.sendMessageToFrame)({
                frameId: this.frameId,
                type: "language.changed",
                frame: this.frame,
                payload: { language: language },
            });
    };
    AIForm.prototype.setConfigLanguage = function (config) {
        if (this.language && config.languages.includes(this.language))
            return;
        this.language = config.defaultLanguage;
    };
    AIForm.prototype.getCustomer = function () {
        return this.customerData;
    };
    AIForm.prototype.setCustomer = function (data) {
        this.customerData = data;
        if (!this.frame)
            return;
        (0, utils_1.sendMessageToFrame)({
            frameId: this.frameId,
            frame: this.frame,
            type: "customer_data.changed",
            payload: { customerData: data },
        });
    };
    AIForm.prototype.getContext = function () {
        return this.context;
    };
    AIForm.prototype.updateContextField = function (payload) {
        this.context = tslib_1.__assign(tslib_1.__assign({}, this.context), payload);
        if (!this.frame)
            return;
        (0, utils_1.sendMessageToFrame)({
            frameId: this.frameId,
            type: "context.patch",
            frame: this.frame,
            payload: payload,
        });
    };
    AIForm.prototype.getColorScheme = function () {
        var _a;
        return this.colorScheme || ((_a = this.config) === null || _a === void 0 ? void 0 : _a.styling.colorScheme);
    };
    AIForm.prototype.setColorScheme = function (colorScheme) {
        if (this.getColorScheme() === colorScheme)
            return;
        if (!types_1.colorSchemes.includes(colorScheme)) {
            console.error("Color scheme is invalid. Must be 'auto', 'light' or 'dark'");
            return;
        }
        this.colorScheme = colorScheme;
        if (!this.frame)
            return;
        (0, utils_1.sendMessageToFrame)({
            frame: this.frame,
            frameId: this.frameId,
            payload: { colorScheme: colorScheme },
            type: "theme.colorscheme.changed",
        });
    };
    AIForm.prototype.setIsFileUploadAllowed = function (enabled) {
        var _a, _b;
        if (!((_b = (_a = this.config) === null || _a === void 0 ? void 0 : _a.permissions) === null || _b === void 0 ? void 0 : _b.isUploadEnabled) && enabled) {
            console.error("File upload not enabled this project");
            return;
        }
        if (!this.frame)
            return;
        this.isFileUploadAllowed = enabled;
        (0, utils_1.sendMessageToFrame)({
            frame: this.frame,
            frameId: this.frameId,
            type: "file_upload.enabled.changed",
            payload: { enabled: enabled },
        });
    };
    AIForm.prototype.getTheme = function () {
        var _a, _b, _c, _d;
        if (this.theme)
            return this.theme;
        var defaultTheme = {
            accentColor: ((_b = (_a = this.config) === null || _a === void 0 ? void 0 : _a.styling) === null || _b === void 0 ? void 0 : _b.backgroundColor) || "#002140",
            accentFontColor: ((_d = (_c = this.config) === null || _c === void 0 ? void 0 : _c.styling) === null || _d === void 0 ? void 0 : _d.fontColor) || "#FFFFFF",
        };
        return {
            light: defaultTheme,
            dark: defaultTheme,
        };
    };
    AIForm.prototype.setTheme = function (theme) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
        var defaultTheme = {
            accentColor: ((_b = (_a = this.config) === null || _a === void 0 ? void 0 : _a.styling) === null || _b === void 0 ? void 0 : _b.backgroundColor) || "#002140",
            accentFontColor: ((_d = (_c = this.config) === null || _c === void 0 ? void 0 : _c.styling) === null || _d === void 0 ? void 0 : _d.fontColor) || "#FFFFFF",
        };
        this.theme = {
            light: tslib_1.__assign(tslib_1.__assign(tslib_1.__assign({}, (((_e = this.theme) === null || _e === void 0 ? void 0 : _e.light) || {})), ((theme === null || theme === void 0 ? void 0 : theme.light) || {})), { accentColor: ((_f = theme === null || theme === void 0 ? void 0 : theme.light) === null || _f === void 0 ? void 0 : _f.accentColor) || defaultTheme.accentColor, accentFontColor: ((_g = theme === null || theme === void 0 ? void 0 : theme.light) === null || _g === void 0 ? void 0 : _g.accentFontColor) || defaultTheme.accentFontColor }),
            dark: tslib_1.__assign(tslib_1.__assign(tslib_1.__assign({}, (((_h = this.theme) === null || _h === void 0 ? void 0 : _h.dark) || {})), ((theme === null || theme === void 0 ? void 0 : theme.dark) || {})), { accentColor: ((_j = theme === null || theme === void 0 ? void 0 : theme.dark) === null || _j === void 0 ? void 0 : _j.accentColor) || defaultTheme.accentColor, accentFontColor: ((_k = theme === null || theme === void 0 ? void 0 : theme.dark) === null || _k === void 0 ? void 0 : _k.accentFontColor) || defaultTheme.accentFontColor }),
        };
        if (!this.frame)
            return;
        (0, utils_1.sendMessageToFrame)({
            frame: this.frame,
            frameId: this.frameId,
            type: "theme.changed",
            payload: { theme: this.theme },
        });
    };
    AIForm.prototype.setConfigTheme = function (config) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p;
        this.theme = {
            light: tslib_1.__assign(tslib_1.__assign({}, (((_a = this.theme) === null || _a === void 0 ? void 0 : _a.light) || {})), { accentColor: ((_c = (_b = this.theme) === null || _b === void 0 ? void 0 : _b.light) === null || _c === void 0 ? void 0 : _c.accentColor) || ((_d = config === null || config === void 0 ? void 0 : config.styling) === null || _d === void 0 ? void 0 : _d.backgroundColor) || "#002140", accentFontColor: ((_f = (_e = this.theme) === null || _e === void 0 ? void 0 : _e.light) === null || _f === void 0 ? void 0 : _f.accentFontColor) || ((_g = config === null || config === void 0 ? void 0 : config.styling) === null || _g === void 0 ? void 0 : _g.fontColor) || "#FFFFFF" }),
            dark: tslib_1.__assign(tslib_1.__assign({}, (((_h = this.theme) === null || _h === void 0 ? void 0 : _h.dark) || {})), { accentColor: ((_k = (_j = this.theme) === null || _j === void 0 ? void 0 : _j.dark) === null || _k === void 0 ? void 0 : _k.accentColor) || ((_l = config === null || config === void 0 ? void 0 : config.styling) === null || _l === void 0 ? void 0 : _l.backgroundColor) || "#002140", accentFontColor: ((_o = (_m = this.theme) === null || _m === void 0 ? void 0 : _m.dark) === null || _o === void 0 ? void 0 : _o.accentFontColor) || ((_p = config === null || config === void 0 ? void 0 : config.styling) === null || _p === void 0 ? void 0 : _p.fontColor) || "#FFFFFF" }),
        };
    };
    AIForm.prototype.setInitialTheme = function (theme) {
        var _a, _b;
        this.theme = {
            light: tslib_1.__assign(tslib_1.__assign({}, (((_a = this.theme) === null || _a === void 0 ? void 0 : _a.light) || {})), theme.light),
            dark: tslib_1.__assign(tslib_1.__assign({}, (((_b = this.theme) === null || _b === void 0 ? void 0 : _b.dark) || {})), theme.dark),
        };
    };
    AIForm.prototype.getTimezone = function () {
        return this.timezone;
    };
    AIForm.prototype.setTimezone = function (timezone) {
        this.timezone = timezone;
        if (!this.frame)
            return;
        (0, utils_1.sendMessageToFrame)({
            frame: this.frame,
            frameId: this.frameId,
            payload: { timezone: timezone },
            type: "timezone.changed",
        });
    };
    AIForm.prototype.getText = function () {
        return this.text;
    };
    AIForm.prototype.setText = function (text) {
        this.text = text;
        if (!this.frame)
            return;
        (0, utils_1.sendMessageToFrame)({ frameId: this.frameId, type: "text.changed", frame: this.frame, payload: { text: text } });
    };
    AIForm.prototype.on = function (event, callback) {
        var id = Date.now().toString(16);
        this.subscriptions.push({ id: id, event: event, callback: callback });
        return id;
    };
    AIForm.prototype.off = function (id) {
        var deletedSubscriptionIndex = this.subscriptions.findIndex(function (subscription) { return subscription.id === id; });
        this.subscriptions.splice(deletedSubscriptionIndex, 1);
        return true;
    };
    AIForm.prototype.initSessionId = function () {
        try {
            if (!window.sessionStorage)
                return;
            var sessions = sessionStorage.getItem(SESSIONID_KEY);
            if (sessions) {
                var parsedSessions = JSON.parse(sessions);
                if (parsedSessions[this.apiKey])
                    return parsedSessions[this.apiKey];
            }
            var sessionId = (0, utils_1.generateId)();
            this.setSessionId(sessionId);
            return sessionId;
        }
        catch (_a) {
            console.error("Script is blocked by browser");
            return;
        }
    };
    AIForm.prototype.setSessionId = function (sessionId) {
        try {
            if (!window.sessionStorage)
                return;
            var sessions = sessionStorage.getItem(SESSIONID_KEY);
            var parsedSessions = sessions ? JSON.parse(sessions) : {};
            parsedSessions[this.apiKey] = sessionId;
            sessionStorage.setItem(SESSIONID_KEY, JSON.stringify(parsedSessions));
        }
        catch (_a) {
            console.error("Script is blocked by browser");
            return;
        }
    };
    AIForm.generateSessionId = function () {
        return (0, utils_1.generateId)();
    };
    AIForm.prototype.unload = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                fetch("".concat(process.env.API_BASE_URL, "/sdk/v1/ai-form/unload?sessionId=").concat(this.sessionId), {
                    headers: { "x-api-key": this.apiKey },
                }).then();
                return [2];
            });
        });
    };
    AIForm.prototype.destroy = function () {
        if (!this.frame)
            return;
        this.unload();
        (0, utils_1.destroyFrames)({ frame: this.frame, selector: this.selector });
        this.subscriptions = [];
        this.frame = undefined;
        this.loaded = false;
    };
    return AIForm;
}());
exports.AIForm = AIForm;
